const publishers = [
  {
    id: 1,
    name: 'BolaVIP',
    bookmakerIdTerm: 'WEB_WIDGET_BOLAVIP_BOOKMAKER_ID',
    bookmakerLinkTerm: 'WEB_WIDGET_BOOKMAKER_LINK_BOLAVIP',
    countryId: 315,
    allScoresLinkTerm: 'WIDGET_SEE_ALL_SCORES_LINK',
  }
];

module.exports = publishers;
